import api from './api';

export interface StatusModuloEconomicoContratado {
  id: string;
  nome: string;
  codigo: string;
}

export const getAllStatusModuloEconomicoContratado = () =>
  api.get<StatusModuloEconomicoContratado[]>('status/moduloEconomicoContratado');

export const getAllStatusModuloEconomicoRequisitado = () =>
  api.get<StatusModuloEconomicoContratado[]>('status/getAllStatusModuloEconomicoRequisitado');


export const getAllOptions = () =>
  getAllStatusModuloEconomicoContratado().then(statusModulo =>
    (statusModulo || []).map(t => ({ text: t.nome, value: t.id.toString() })),
  );

export const getAllOptionsStatusModuloEconomicoContratado = () =>
  getAllStatusModuloEconomicoContratado().then(statusModulo =>
    (statusModulo || []).map(t => ({ text: t.nome, value: t.id.toString() })),
  );


export const getAllOptionsStatusModuloEconomicoRequisitado = () =>
  getAllStatusModuloEconomicoRequisitado().then(statusModulo =>
    (statusModulo || []).map(t => ({ text: t.nome, value: t.id.toString() })),
  );
